import { render, staticRenderFns } from "./srights.vue?vue&type=template&id=614a504a&scoped=true&"
import script from "./srights.vue?vue&type=script&lang=js&"
export * from "./srights.vue?vue&type=script&lang=js&"
import style0 from "./srights.vue?vue&type=style&index=0&id=614a504a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614a504a",
  null
  
)

export default component.exports